module.exports = __webpack_public_path__ + "static/img/visa-straight-128px.70dc9404.png";